var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._b({
    staticClass: "caption point-btn",
    attrs: {
      "text": "",
      "block": "",
      "tile": "",
      "color": "secondary",
      "height": "54px"
    }
  }, 'v-btn', {
    to: _vm.to
  }, false), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }